/**
 * Styled tick for RightRevenue
 */

import styled from 'styled-components';
import BasicTick from './BasicTick';

const StyledTick = styled(BasicTick)`
    font: inherit;
    font-size: ${({ fontSize = 10 }) => `${fontSize}px`};
    color: ${({ theme }) => theme.text};
`;

export default StyledTick;
